import { useEffect, useState } from "react";
import api from "../lib/api";

export const useUserSearch = (q) => {
  const [results, setResults] = useState([]);
  useEffect(() => {
    if (q == null || q.length < 1) { setResults([]); return; }
    let live = true;
    const t = setTimeout(() => {
      api.get("/search/users", { params: { q, limit: 6 } })
        .then(({ data }) => live && setResults(data))
        .catch(() => live && setResults([]));
    }, 180);
    return () => { live = false; clearTimeout(t); };
  }, [q]);
  return results;
};
